import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const SERVER_BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

// Helper function to get full attachment URL
export const getAttachmentUrl = (filePath) => {
  console.log('getAttachmentUrl called with:', filePath);
  
  // If path already starts with http, return as is
  if (filePath.startsWith('http')) {
    console.log('Returning as-is (http URL):', filePath);
    return filePath;
  }
  
  // Remove leading slash if present to avoid double slashes
  const cleanPath = filePath.startsWith('/') ? filePath.substring(1) : filePath;
  const finalUrl = `${SERVER_BASE_URL}/${cleanPath}`;
  
  console.log('SERVER_BASE_URL:', SERVER_BASE_URL);
  console.log('Clean path:', cleanPath);
  console.log('Final URL:', finalUrl);
  
  return finalUrl;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// User APIs
export const userAPI = {
  register: (data) => api.post('/users/register', data),
  login: (data) => api.post('/users/login', data),
  getAllUsers: () => api.get('/users'),
  getUser: (id) => api.get(`/users/${id}`),
};

// Ticket APIs
export const ticketAPI = {
  createTicket: (formData) => {
    return axios.post(`${API_BASE_URL}/tickets`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getAllTickets: (params) => api.get('/tickets', { params }),
  getTicket: (id) => api.get(`/tickets/${id}`),
  updateStatus: (id, data) => api.patch(`/tickets/${id}/status`, data),
  withdrawTicket: (id, data) => api.patch(`/tickets/${id}/withdraw`, data),
};

// Complaint Type APIs
export const complaintTypeAPI = {
  getAll: () => api.get('/complaint-types'),
  create: (data) => api.post('/complaint-types', data),
};

export default api;